import { EntityType } from 'models/entity-permission.model';

const entityPermissionMutationKeys = {
    grantPermission: (entityType: EntityType, entityId: string) => [
        'entity-permission',
        'grant',
        entityType,
        entityId,
    ],
    revokePermission: (entityType: EntityType, entityId: string) => [
        'entity-permission',
        'revoke',
        entityType,
        entityId,
    ],
};

export default entityPermissionMutationKeys;
